var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "invoice",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.455,
    height: 25.94,
    viewBox: "0 0 19.455 25.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(12.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M320,0V6.485h6.485Z",
    transform: "translate(-320)",
    fill: "#324562"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M76.97,8.106a1.624,1.624,0,0,1-1.621-1.621V0H65.621A1.624,1.624,0,0,0,64,1.621v22.7a1.623,1.623,0,0,0,1.621,1.621H81.834a1.622,1.622,0,0,0,1.621-1.621V8.106Zm-7.3-3.142V4.053a.811.811,0,1,1,1.621,0v.913a3.332,3.332,0,0,1,1.372.647.81.81,0,0,1-1.023,1.256,1.84,1.84,0,0,0-1.159-.384c-.879,0-1.621.556-1.621,1.216s.743,1.216,1.621,1.216a3.064,3.064,0,0,1,3.243,2.837A2.935,2.935,0,0,1,71.3,14.491V15.4a.811.811,0,1,1-1.621,0v-.913a3.332,3.332,0,0,1-1.372-.647.811.811,0,0,1,1.023-1.258,1.832,1.832,0,0,0,1.159.386c.879,0,1.621-.556,1.621-1.216s-.743-1.216-1.621-1.216A3.064,3.064,0,0,1,67.243,7.7,2.935,2.935,0,0,1,69.674,4.964ZM79.4,22.7H68.053a.811.811,0,1,1,0-1.621H79.4a.811.811,0,0,1,0,1.621Zm0-3.243H68.053a.811.811,0,1,1,0-1.621H79.4a.811.811,0,0,1,0,1.621Zm0-3.243H76.16a.811.811,0,0,1,0-1.621H79.4a.811.811,0,0,1,0,1.621Zm0-3.243H76.16a.811.811,0,0,1,0-1.621H79.4a.811.811,0,0,1,0,1.621Z",
    transform: "translate(-64)",
    fill: "#324562"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/Invoice.4ddb85cd56badea660eed7bf13a327ce.svg";
export { ForwardRef as ReactComponent };